<template>
  <v-container>
    <v-app-bar app color="secondary" dark dense>
      <v-toolbar-title>
        {{ $t("nav.user.bookings") }}
      </v-toolbar-title>
    </v-app-bar>

    <v-row>
      <v-col cols="12">
        <Offers />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <BookingForm />
      </v-col>
    </v-row>

    <v-row v-if="currentUser && requests.length">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            {{ $t("user.bookings.requests.title") }}
          </v-card-title>

          <v-card-text>
            <v-card v-for="(booking, index) in requests" :key="index" class="mb-4">
              <v-card-title>
                {{ booking.year }}
              </v-card-title>

              <v-simple-table class="table-no-hover" dense>
                <template #default>
                  <tbody>
                    <tr v-for="(fund, index) in booking.funds" :key="index">
                      <td width="50%">
                        {{ fund.name }}
                      </td>
                      <td>{{ $t(`bookings.fund.type.${fund.type}`) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="currentUser && accepted.length">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            {{ $t("user.bookings.accepted.title") }}
          </v-card-title>

          <v-simple-table dense>
            <template #default>
              <thead>
                <tr>
                  <th width="20%">{{ $t("user.bookings.auditPeriod.title") }}</th>
                  <th width="20%">{{ $t("user.bookings.funds.title") }}</th>
                  <th width="20%">{{ $t("user.bookings.grossTotal.title") }}</th>
                  <th width="20%">{{ $t("user.bookings.acceptedAt.title") }}</th>
                  <th width="1%">{{ $t("user.bookings.invoice.title") }}</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="booking in accepted" :key="booking.id">
                  <td>{{ booking.year }}</td>
                  <td>{{ booking.funds.length }}</td>
                  <td>{{ formatCurrency(booking.grossTotal) }}</td>
                  <td>
                    {{
                      new Date(booking.acceptedAt).toLocaleString(undefined, {
                        timeZone: "CET",
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                    }}
                  </td>
                  <td>
                    <v-btn v-if="booking.invoice" :href="booking.invoice.url" target="_blank" color="secondary" icon>
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="currentUser && rejected.length">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            {{ $t("user.bookings.rejected.title") }}
          </v-card-title>

          <v-simple-table dense>
            <template #default>
              <thead>
                <tr>
                  <th width="25%">{{ $t("user.bookings.auditPeriod.title") }}</th>
                  <th width="25%">{{ $t("user.bookings.funds.title") }}</th>
                  <th width="25%">{{ $t("user.bookings.grossTotal.title") }}</th>
                  <th width="25%">{{ $t("user.bookings.rejectedAt.title") }}</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="booking in rejected" :key="booking.id">
                  <td>{{ booking.year }}</td>
                  <td>{{ booking.funds.length }}</td>
                  <td>{{ formatCurrency(booking.grossTotal) }}</td>
                  <td>
                    {{
                      new Date(booking.rejectedAt).toLocaleString(undefined, {
                        timeZone: "CET",
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { filter, propEq, reverse } from "ramda";
import BookingsQuery from "@/gql/queries/BookingsQuery.gql";
import BookingForm from "@/components/User/BookingForm.vue";
import Offers from "@/components/User/Booking/Offers.vue";

export default {
  components: {
    BookingForm,
    Offers,
  },

  data() {
    return {
      currentUser: null,
    };
  },

  computed: {
    requests() {
      return reverse(filter(propEq("state", "REQUESTED"), this.currentUser.bookings));
    },

    offers() {
      return reverse(filter(propEq("state", "OFFERED"), this.currentUser.bookings));
    },

    accepted() {
      return reverse(filter(propEq("state", "ACCEPTED"), this.currentUser.bookings));
    },

    rejected() {
      return reverse(filter(propEq("state", "REJECTED"), this.currentUser.bookings));
    },
  },

  apollo: {
    currentUser: {
      query: BookingsQuery,
      fetchPolicy: "cache-and-network",
    },
  },

  methods: {
    formatCurrency: new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format,
  },
};
</script>
